import {hasValue, notSet} from "./ValueUtils";

function isEmpty(v: unknown) {
    return notSet(v) || v === "";
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeEmptyKeys(obj: any) {
    if (!obj) {
        return;
    }
    for (const key in obj) {
        if (isEmpty(obj[key])) {
            delete obj[key];
        }
    }
}

/**
 * Indicates if the supplied object implements the Iterable interface.
 *
 * @param obj The object to test
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isIterable(obj: any): boolean {
    return hasValue(obj) && typeof obj[Symbol.iterator] === "function";
}
